<template>
  <div class="notice" :style="{'paddingTop': statusBar + 'rem'}" ref="getheigh">
    <Header title="培训材料" :back="true" left="返回" :white="true" />
    <div class="noticemain" ref="getheight">
      <ul class="list">

        <li v-for="(item, i) in noticList" :key="i" @click="gotoNotice(item.noticeUrl)">
          <p class="redio">
            <span></span>
          </p>
          <p class="text">
            <span class="text1">{{item.noticeTitle}}</span>
            <span class="text2">{{item.publishtime}}</span>
          </p>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
export default {
  name: "train",
  /**
   * 初始化数据
   */
  data() {
    return {
      noticList: [],
      backormoren: true,
      statusBar: 0,
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
    };
  },
  /**
   * 初始化
   */
  mounted() {
    this.statusBar = this.$tool.statusBar(44);
    this.getMobileNoticList();
    console.log(window.scrollY);
  },
  updated() {
    /**
     * 页面加载完毕后Y轴置在最顶端
     * bug出现形式未知
     */
    window.scroll(0, 0);
    console.log("nextTick " + window.scrollY);
  },

  /**
   * 方法
   */
  methods: {
    /**
     * 获取首页menu数据
     */
    getMobileNoticList() {


      this.noticList.push({"noticeId":"1","noticeTitle":"单一窗口标准版原产地证申报系统培训材料","noticeUrl":"/dbfile.svl?n=/u/cms/www/201905/30165047e8pl.pptx","publishtime":"2019/05/30","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"2","noticeTitle":"单一窗口货物申报系统培训材料","noticeUrl":"/dbfile.svl?n=/u/cms/www/201709/29164929culx.pptx","publishtime":"2017/09/29","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"3","noticeTitle":"（完整版）中国国际贸易“单一窗口”标准版-关检融合统一申报","noticeUrl":"/dbfile.svl?n=/u/cms/www/201807/11194224affv.pptx","publishtime":"2018/07/11","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"4","noticeTitle":"单一窗口标准版舱单(公路)系统培训材料","noticeUrl":"/dbfile.svl?n=/u/cms/www/201807/27151451wa63.pptx","publishtime":"2018/07/27","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
      this.noticList.push({"noticeId":"5","noticeTitle":"单一窗口标准版税费电子支付系统培训材料","noticeUrl":"/dbfile.svl?n=/u/cms/www/201807/27193148pf2k.pptx","publishtime":"2018/07/27","endtime":"2029/12/22","publisher":"电子口岸数据中心","istop":"1","status":"1","creatTime":"2020-12-18 15:52:52","note":null,"noticeContent":null})
/*      this.$http1
        .post("/zsdyckserver/app/notice/getNotices", {})
        .then((res) => {
          this.noticList = res.resultData;
        })
        .catch((err) => {
          if (err === 302) {
            window.console.log(err);
          }
        });
*/        
    },

    /**
     * 跳转小应用
     */
    gotoNotice(noticeUrl) {
      this.backormoren = false;

      window.location.href = 'http://www.singlewindow.cn'+noticeUrl
    },
  },
  components: {
    Header,
  },
};
</script>

<style scoped lang="scss">
.notice {
  width: 100%;
  background: #f7f8fa;
  .noticemain {
    overflow: auto;
    background: #fff;
    .list {
      padding-top: 12px;
      li {
        display: flex;
        margin: 0 12px;
        .redio {
          width: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          span {
            width: 6px;
            height: 6px;
            display: block;
            background: #a0a5aa;
            border-radius: 50%;
          }
        }
        .text {
          flex: 1;
          display: flex;
          padding: 20px 0;
          border-bottom: 1px solid $lineColor;
          .text1 {
            font-size: 12px;
            line-height: 14px;
            display: block;
            color: $fontColor;
            width: 250px;
            white-space: nowrap; //强制不换行
            overflow: hidden; //自动隐藏文字
            text-overflow: ellipsis; //文字隐藏后添加省略号
            -o-text-overflow: ellipsis; //适用于opera浏览器
          }
          .text2 {
            text-align: right;
            width: 80px;
            color: #a0a5aa;
            line-height: 14px;
            display: block;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>

